module.exports = __webpack_public_path__ + "static/media/NightLight.ef7e85ad.svg";